<ng-template #content let-modal>
    <!-- <div class="modal-header">
    </div> -->
    <form ngNoForm [action]="'https://formspree.io/f/mrgjnjgz'" method="POST" class="centerAlign">
        <div class="modal-body">
            <h1>Contact us</h1>
            <div>
                <br/>
                <label class="label1">
                    <span>Email Address:</span><br/>
                    <input type="email" name="email">
                </label>
                <br/><br/>
                <label class="label2">
                    <span>Message</span> <br/>
                    <textarea name="message" rows="6" cols="28"></textarea>
                </label>
            </div>
            <br/>
            <!-- your other form fields go here -->
            <div class="subOrClose" *ngIf="mobile">
              
                        <button type="submit" class="btn sendBtn mb-4">Send</button>
                        <button type="button" class="btn btn-danger closeBtn" (click)="modal.close('Close')">Close</button>
               
    
            </div>
            <div class="subOrClose" *ngIf="!mobile">
              
                <button type="submit" class="btn sendBtn">Send</button>
                <button type="button" class="btn btn-danger closeBtn" (click)="modal.close('Close')">Close</button>
       

    </div>
        </div>
        <!-- <div class="modal-footer justCenter">
        </div> -->
    </form>
    <br />
</ng-template>

<button class="btn btn--transparent mobilePos theBtn contactBtn" (click)="open(content)">Contact Us</button>


<!-- modify this form HTML and place wherever you want your form -->